module.exports = __webpack_public_path__ + "img/390a.81af07ce.png";